export const translations: Record<string, Record<string, string>> = {
  nl: {
    'model.refused': 'Het datamodel is geweigerd; het vorige model blijft actief.',
    'model.failed': 'Het datamodel kon niet worden geladen; er is geen model actief.',
    'model.view_details': 'Bekijk details',
    'model.reload_failed': 'Het model kon niet opnieuw worden geladen.',
    'model.title': 'Modelstatus',
    'model.loading': 'Laden…',
    'model.load_failed': 'De modelstatus kon niet worden opgehaald.',
    'model.state': 'Status',
    'model.state.LOADED': 'Geladen',
    'model.state.REFUSED': 'Geweigerd',
    'model.state.FAILED': 'Mislukt',
    'model.checked_at': 'Gecontroleerd op',
    'model.errors': 'Fouten',
    'model.warnings': 'Waarschuwingen',
    'model.none': 'Geen',
    'model.file': 'Bestand',
    'model.path': 'Pad',
    'model.message': 'Melding',
    'model.upgrade_title': 'Upgrade naar het nieuwste definitieformaat',
    'model.upgrade_body': '{count} definitiebestand(en) gebruiken een ouder formaat. Download de upgrade, pak het zip-bestand uit over de root van de repository, controleer de diff en commit.',
    'model.upgrade_button': 'Download upgrade',
    'model.upgrade_failed': 'De upgrade kon niet worden gemaakt; de modelbestanden kunnen niet worden geladen.',
    'login.invite_welcome': 'Je bent uitgenodigd',
    'login.invite_subtitle': 'Log in om je uitnodiging te accepteren',
    'login.invite_processing': 'Uitnodiging verwerken…',
    'login.invite_used_title': 'Uitnodiging niet meer geldig',
    'login.invite_used_body': 'Deze uitnodigingslink is verlopen of al gebruikt. Vraag een nieuwe uitnodiging aan.',
    'login.invite_error_title': 'Er is iets misgegaan',
    'login.invite_error_body': 'De uitnodiging kon niet worden verwerkt. Probeer het later opnieuw.',
    'profile.manage_workspace': 'Beheer werkruimte',
    'profile.switch': 'Wisselen',
    'profile.all_workspaces': '› Alle werkruimtes',
    'profile.logout': 'Uitloggen',
    'login.welcome': 'Welkom terug',
    'login.subtitle': 'Log in om verder te gaan',
    'login.microsoft': 'Doorgaan met Microsoft',
    'login.google': 'Doorgaan met Google',
    'login.email': 'Doorgaan met e-mail',
    'login.footer': 'Mosterd — Content Management',
    'import.failed': 'De import is mislukt.',
    'import.upload_failed': 'Het bestand kon niet worden geüpload.',
    'notification.row': 'Rij',
    'confirm.delete_title': 'Verwijderen?',
    'confirm.delete_body': 'Dit item wordt definitief verwijderd. Deze actie kan niet ongedaan worden gemaakt.',
    'confirm.cancel': 'Annuleren',
    'confirm.delete': 'Verwijderen',
    'delete.failed': 'Verwijderen is mislukt.',
    'save.failed': 'Opslaan is mislukt.',
  },
  en: {
    'model.refused': 'The data model was refused; the previous model is still active.',
    'model.failed': 'The data model could not be loaded; no model is active.',
    'model.view_details': 'View details',
    'model.reload_failed': 'The model could not be reloaded.',
    'model.title': 'Model status',
    'model.loading': 'Loading…',
    'model.load_failed': 'The model status could not be retrieved.',
    'model.state': 'State',
    'model.state.LOADED': 'Loaded',
    'model.state.REFUSED': 'Refused',
    'model.state.FAILED': 'Failed',
    'model.checked_at': 'Checked at',
    'model.errors': 'Errors',
    'model.warnings': 'Warnings',
    'model.none': 'None',
    'model.file': 'File',
    'model.path': 'Path',
    'model.message': 'Message',
    'model.upgrade_title': 'Upgrade to the latest definition format',
    'model.upgrade_body': '{count} definition file(s) use an older format. Download the upgrade, unzip it over the root of the repository, review the diff and commit.',
    'model.upgrade_button': 'Download upgrade',
    'model.upgrade_failed': 'The upgrade could not be created; the model files do not load.',
    'login.invite_welcome': 'You\'ve been invited',
    'login.invite_subtitle': 'Sign in to accept your invitation',
    'login.invite_processing': 'Processing invitation…',
    'login.invite_used_title': 'Invitation no longer valid',
    'login.invite_used_body': 'This invite link has expired or already been used. Please request a new invitation.',
    'login.invite_error_title': 'Something went wrong',
    'login.invite_error_body': 'The invitation could not be processed. Please try again later.',
    'profile.manage_workspace': 'Manage workspace',
    'profile.switch': 'Switch',
    'profile.all_workspaces': '› All workspaces',
    'profile.logout': 'Log out',
    'login.welcome': 'Welcome back',
    'login.subtitle': 'Sign in to continue',
    'login.microsoft': 'Continue with Microsoft',
    'login.google': 'Continue with Google',
    'login.email': 'Continue with email',
    'login.footer': 'Mosterd — Content Management',
    'import.failed': 'The import failed.',
    'import.upload_failed': 'The file could not be uploaded.',
    'notification.row': 'Row',
    'confirm.delete_title': 'Delete?',
    'confirm.delete_body': 'This item will be permanently deleted. This cannot be undone.',
    'confirm.cancel': 'Cancel',
    'confirm.delete': 'Delete',
    'delete.failed': 'Deleting failed.',
    'save.failed': 'Saving failed.',
  },
  de: {
    'model.refused': 'Das Datenmodell wurde abgelehnt; das vorherige Modell bleibt aktiv.',
    'model.failed': 'Das Datenmodell konnte nicht geladen werden; kein Modell ist aktiv.',
    'model.view_details': 'Details anzeigen',
    'model.reload_failed': 'Das Modell konnte nicht neu geladen werden.',
    'model.title': 'Modellstatus',
    'model.loading': 'Laden…',
    'model.load_failed': 'Der Modellstatus konnte nicht abgerufen werden.',
    'model.state': 'Status',
    'model.state.LOADED': 'Geladen',
    'model.state.REFUSED': 'Abgelehnt',
    'model.state.FAILED': 'Fehlgeschlagen',
    'model.checked_at': 'Geprüft am',
    'model.errors': 'Fehler',
    'model.warnings': 'Warnungen',
    'model.none': 'Keine',
    'model.file': 'Datei',
    'model.path': 'Pfad',
    'model.message': 'Meldung',
    'model.upgrade_title': 'Upgrade auf das neueste Definitionsformat',
    'model.upgrade_body': '{count} Definitionsdatei(en) verwenden ein älteres Format. Laden Sie das Upgrade herunter, entpacken Sie es über das Repository-Root, prüfen Sie den Diff und committen Sie.',
    'model.upgrade_button': 'Upgrade herunterladen',
    'model.upgrade_failed': 'Das Upgrade konnte nicht erstellt werden; die Modelldateien lassen sich nicht laden.',
    'profile.manage_workspace': 'Arbeitsbereich verwalten',
    'profile.switch': 'Wechseln',
    'profile.all_workspaces': '› Alle Arbeitsbereiche',
    'profile.logout': 'Abmelden',
    'login.welcome': 'Willkommen zurück',
    'login.subtitle': 'Melden Sie sich an, um fortzufahren',
    'login.microsoft': 'Mit Microsoft anmelden',
    'login.google': 'Mit Google anmelden',
    'login.email': 'Mit E-Mail anmelden',
    'login.footer': 'Mosterd — Content Management',
    'import.failed': 'Der Import ist fehlgeschlagen.',
    'import.upload_failed': 'Die Datei konnte nicht hochgeladen werden.',
    'notification.row': 'Zeile',
    'confirm.delete_title': 'Löschen?',
    'confirm.delete_body': 'Dieses Element wird endgültig gelöscht. Das kann nicht rückgängig gemacht werden.',
    'confirm.cancel': 'Abbrechen',
    'confirm.delete': 'Löschen',
    'delete.failed': 'Löschen fehlgeschlagen.',
    'save.failed': 'Speichern fehlgeschlagen.',
  },
  fr: {
    'model.refused': 'Le modèle de données a été refusé ; le modèle précédent reste actif.',
    'model.failed': 'Le modèle de données n\'a pas pu être chargé ; aucun modèle n\'est actif.',
    'model.view_details': 'Voir les détails',
    'model.reload_failed': 'Le modèle n\'a pas pu être rechargé.',
    'model.title': 'État du modèle',
    'model.loading': 'Chargement…',
    'model.load_failed': 'L\'état du modèle n\'a pas pu être récupéré.',
    'model.state': 'État',
    'model.state.LOADED': 'Chargé',
    'model.state.REFUSED': 'Refusé',
    'model.state.FAILED': 'Échec',
    'model.checked_at': 'Vérifié le',
    'model.errors': 'Erreurs',
    'model.warnings': 'Avertissements',
    'model.none': 'Aucun',
    'model.file': 'Fichier',
    'model.path': 'Chemin',
    'model.message': 'Message',
    'model.upgrade_title': 'Mise à niveau vers le dernier format de définition',
    'model.upgrade_body': '{count} fichier(s) de définition utilisent un ancien format. Téléchargez la mise à niveau, décompressez-la à la racine du dépôt, vérifiez le diff et faites un commit.',
    'model.upgrade_button': 'Télécharger la mise à niveau',
    'model.upgrade_failed': 'La mise à niveau n\'a pas pu être créée ; les fichiers du modèle ne se chargent pas.',
    'profile.manage_workspace': 'Gérer l\'espace de travail',
    'profile.switch': 'Changer',
    'profile.all_workspaces': '› Tous les espaces',
    'profile.logout': 'Se déconnecter',
    'login.welcome': 'Bon retour',
    'login.subtitle': 'Connectez-vous pour continuer',
    'login.microsoft': 'Continuer avec Microsoft',
    'login.google': 'Continuer avec Google',
    'login.email': 'Continuer avec l\'e-mail',
    'login.footer': 'Mosterd — Content Management',
    'import.failed': 'L\'import a échoué.',
    'import.upload_failed': 'Le fichier n\'a pas pu être téléversé.',
    'notification.row': 'Ligne',
    'confirm.delete_title': 'Supprimer ?',
    'confirm.delete_body': 'Cet élément sera définitivement supprimé. Cette action est irréversible.',
    'confirm.cancel': 'Annuler',
    'confirm.delete': 'Supprimer',
    'delete.failed': 'La suppression a échoué.',
    'save.failed': 'L\'enregistrement a échoué.',
  },
  es: {
    'profile.manage_workspace': 'Gestionar espacio de trabajo',
    'profile.switch': 'Cambiar',
    'profile.all_workspaces': '› Todos los espacios',
    'profile.logout': 'Cerrar sesión',
    'login.welcome': 'Bienvenido de nuevo',
    'login.subtitle': 'Inicia sesión para continuar',
    'login.microsoft': 'Continuar con Microsoft',
    'login.google': 'Continuar con Google',
    'login.email': 'Continuar con correo electrónico',
    'login.footer': 'Mosterd — Content Management',
    'import.failed': 'La importación ha fallado.',
    'import.upload_failed': 'No se pudo subir el archivo.',
    'notification.row': 'Fila',
    'confirm.delete_title': '¿Eliminar?',
    'confirm.delete_body': 'Este elemento se eliminará de forma permanente. Esta acción no se puede deshacer.',
    'confirm.cancel': 'Cancelar',
    'confirm.delete': 'Eliminar',
    'delete.failed': 'No se pudo eliminar.',
    'save.failed': 'No se pudo guardar.',
  },
  it: {
    'profile.manage_workspace': 'Gestisci area di lavoro',
    'profile.switch': 'Cambia',
    'profile.all_workspaces': '› Tutte le aree di lavoro',
    'profile.logout': 'Disconnetti',
    'login.welcome': 'Bentornato',
    'login.subtitle': 'Accedi per continuare',
    'login.microsoft': 'Continua con Microsoft',
    'login.google': 'Continua con Google',
    'login.email': 'Continua con email',
    'login.footer': 'Mosterd — Content Management',
    'import.failed': 'L\'importazione non è riuscita.',
    'import.upload_failed': 'Impossibile caricare il file.',
    'notification.row': 'Riga',
    'confirm.delete_title': 'Eliminare?',
    'confirm.delete_body': 'Questo elemento verrà eliminato definitivamente. L\'operazione non può essere annullata.',
    'confirm.cancel': 'Annulla',
    'confirm.delete': 'Elimina',
    'delete.failed': 'Eliminazione non riuscita.',
    'save.failed': 'Salvataggio non riuscito.',
  },
  pt: {
    'profile.manage_workspace': 'Gerir espaço de trabalho',
    'profile.switch': 'Mudar',
    'profile.all_workspaces': '› Todos os espaços',
    'profile.logout': 'Terminar sessão',
    'login.welcome': 'Bem-vindo de volta',
    'login.subtitle': 'Inicie sessão para continuar',
    'login.microsoft': 'Continuar com Microsoft',
    'login.google': 'Continuar com Google',
    'login.email': 'Continuar com e-mail',
    'login.footer': 'Mosterd — Content Management',
    'import.failed': 'A importação falhou.',
    'import.upload_failed': 'Não foi possível carregar o ficheiro.',
    'notification.row': 'Linha',
    'confirm.delete_title': 'Eliminar?',
    'confirm.delete_body': 'Este item será eliminado permanentemente. Esta ação não pode ser anulada.',
    'confirm.cancel': 'Cancelar',
    'confirm.delete': 'Eliminar',
    'delete.failed': 'Não foi possível eliminar.',
    'save.failed': 'Não foi possível guardar.',
  },
  pl: {
    'profile.manage_workspace': 'Zarządzaj obszarem roboczym',
    'profile.switch': 'Przełącz',
    'profile.all_workspaces': '› Wszystkie obszary',
    'profile.logout': 'Wyloguj się',
    'login.welcome': 'Witamy z powrotem',
    'login.subtitle': 'Zaloguj się, aby kontynuować',
    'login.microsoft': 'Kontynuuj z Microsoft',
    'login.google': 'Kontynuuj z Google',
    'login.email': 'Kontynuuj z e-mailem',
    'login.footer': 'Mosterd — Content Management',
    'import.failed': 'Import nie powiódł się.',
    'import.upload_failed': 'Nie udało się przesłać pliku.',
    'notification.row': 'Wiersz',
    'confirm.delete_title': 'Usunąć?',
    'confirm.delete_body': 'Ten element zostanie trwale usunięty. Tej operacji nie można cofnąć.',
    'confirm.cancel': 'Anuluj',
    'confirm.delete': 'Usuń',
    'delete.failed': 'Usuwanie nie powiodło się.',
    'save.failed': 'Zapisywanie nie powiodło się.',
  },
  uk: {
    'profile.manage_workspace': 'Управління робочим простором',
    'profile.switch': 'Змінити',
    'profile.all_workspaces': '› Усі робочі простори',
    'profile.logout': 'Вийти',
    'login.welcome': 'З поверненням',
    'login.subtitle': 'Увійдіть, щоб продовжити',
    'login.microsoft': 'Продовжити з Microsoft',
    'login.google': 'Продовжити з Google',
    'login.email': 'Продовжити з email',
    'login.footer': 'Mosterd — Content Management',
    'import.failed': 'Не вдалося виконати імпорт.',
    'import.upload_failed': 'Не вдалося завантажити файл.',
    'notification.row': 'Рядок',
    'confirm.delete_title': 'Видалити?',
    'confirm.delete_body': 'Цей елемент буде остаточно видалено. Цю дію не можна скасувати.',
    'confirm.cancel': 'Скасувати',
    'confirm.delete': 'Видалити',
    'delete.failed': 'Не вдалося видалити.',
    'save.failed': 'Не вдалося зберегти.',
  },
};
